export enum CalendarPageTab {
    WO = 'Work Orders',
    PM = 'Maintenance',
}
